import { type FunctionComponent } from 'react';
import { BrandLinks } from '../../../../../components/product-components/brand-links/brand-links.component';
import { ManufacturerResources } from '../../../../../components/product-components/manufacturer-resource/manufacturer-resource.component';
import { ProductAttributes } from '../../../../../components/product-components/product-attributes/product-attributes.component';
import { ProductDescription } from '../../../../../components/product-components/product-description/product-description.component';
import { RelatedCategoriesList } from '../../../../../components/product-components/related-categories-list/related-categories-list.component';
import { RelatedCategoriesPanel } from '../../../../../components/product-components/related-categories-panel/related-categories-panel.component';
import { FEATURE_FLAGS } from '../../../../../constants/feature-flags';
import { useFeature } from '../../../../../hooks/features/features.hooks';
import { type PdpProductFamily } from '../../../../../types/product.types';

export type ProductOverviewProps = {
	product: PdpProductFamily;
};

export const ProductOverview: FunctionComponent<ProductOverviewProps> = ({ product }) => {
	const luxSpecsSectionActive = useFeature(FEATURE_FLAGS.LUXURY_PDP_SPECS_SECTION, { isSiteWide: true });

	return (
		<div className="flex flex-wrap f5" data-testid="product-overview-body">
			<div className="w-100 w-two-thirds-ns pr3">
				{product.description && <ProductDescription description={product.description} />}
				{!luxSpecsSectionActive && (
					<div className="mt-4 print:hidden">
						<BrandLinks brand={product.brandInfo} collection={product.collection} />
					</div>
				)}
			</div>
			<div className="w-100 w-third-ns">
				{luxSpecsSectionActive ? (
					<div className="print:hidden">
						<div className="mt-4">
							<BrandLinks brand={product.brandInfo} collection={product.collection} />
						</div>
						<div className="mt-4">
							<RelatedCategoriesList brand={product.brandInfo} categories={product.relatedCategories} />
						</div>
					</div>
				) : (
					<>
						<div className="print:hidden">
							{product.resources && product.resources.length > 0 && <ManufacturerResources resources={product.resources} />}
						</div>
						{product.attributeGroups?.map((attributeGroup) => (
							<div className="page-avoid-p" key={attributeGroup.name}>
								<ProductAttributes headingValue="h3" attributeGroup={attributeGroup} />
							</div>
						))}
						<div className="mt-4 print:hidden">
							<RelatedCategoriesPanel brand={product.brandInfo} categories={product.relatedCategories} />
						</div>
					</>
				)}
			</div>
		</div>
	);
};
